import React from 'react'
import { useNavigate } from "react-router-dom";

import { Header } from '../../../component/Typogaphy/Header';
import { BackgroundAuth } from '../../../component/Auth/BackgroundAuth';

import EnterOTP from '../../../assets/images/EnterOTP.gif';
import Email from '../../../assets/images/Email.gif';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { Alert, CircularProgress, Divider } from '@mui/material';

import { FaUserCircle } from "react-icons/fa";

import { pageRoutes } from '../../../routes/pageRoutes';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { APIServices } from '../../../hooks/fetchAPI';


export const VerifyChangePasswordEmail = ({ handleStep }) => {

    const navigate = useNavigate();

    const [email, setEmail] = React.useState('');
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState('');
    const [success, setSuccess] = React.useState('');

    const handleVerify = async () => {
        setError('');
        if (!email) {
            setError('Email is required');
            return;
        }
        setLoading(true);
        try {
            const data = { email: email };
            const response = await APIServices.post({ url: `/forgot-password`, payload: data });

            if (response?.status === 200) {
                setSuccess('Verification email sent successfully');
                setTimeout(() => {
                    navigate(pageRoutes.LOGIN);
                }, 1500);
            } else {
                setError('Invalid email address');
            }
        } catch (err) {
            setError(err?.response?.data?.message || 'Something went wrong');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='w-full  bg-white max-w-[850px] rounded-lg p-3 flex flex-col gap-2 '>

            <div className='flex flex-row items-center gap-2 w-full justify-between'>
                <div className='max-w-[400px] w-full max-h-[500px] h-full flex flex-col  items-center justify-center border-r pr-4'>
                    <img className='h-full w-full' src={Email} alt='N/A' />
                </div>

                <div className='flex flex-col max-w-[800px] w-full  items-center gap-2 px-5 py-2'>
                    <div className='w-full items-center flex flex-col gap-2 my-3 '>
                        <div className='flex flex-col items-center gap-2'>

                            <AccountCircleIcon sx={{ color: '#556fa8' }} fontSize="large" />

                            <div className='self-center'>
                                <img class="default_logo lazyloaded" src="https://www.sixelevenbpo.com/wp-content/uploads/2020/05/six-eleven-center-logo.png" alt="six-eleven-center-logo" data-ll-status="loaded" />
                            </div>

                            <h1 className='text-xs text-[#556fa8] font-semibold self-center'>Forgot Password</h1>
                        </div>



                        <div className='w-full flex flex-col gap-3 mb-10   border-gray-200 p-3'>
                            <FormControl sx={{ width: '100%' }}>
                                <span className='mb-3 font-medium text-[#556fa8]'>Enter Registered Email:</span>
                                <TextField
                                    id="outlined-required"
                                    type='email'
                                    placeholder="type here..."
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                />
                            </FormControl>

                            {error && <Alert severity="error" >{error}</Alert>
                            }

                            {success && <Alert severity="success">{success}</Alert>
                            }

                            <div onClick={handleVerify} className='w-full font-lexend  bg-[#2e6b1f] flex flex-col items-center justify-center rounded py-2 cursor-pointer text-white font-medium hover:bg-[#556fa8]'>
                                {loading ? <CircularProgress color='white' /> : <span>Verify</span>}
                            </div>
                        </div>
                    </div>


                    <div className='w-full gap-2 flex flex-col'>
                        <div className='mt-2'><Divider /></div>

                        <div className='w-full justify-center flex flex-row gap-2'>
                            <span className='text-black font-light text-md font-lexend'>Already have an account?</span>
                            <span onClick={() => navigate(pageRoutes.LOGIN)} className='text-[#2e6b1f] font-medium font-lexend text-md cursor-pointer hover:text-[#556fa8]'>Sign In Now</span>
                        </div>
                    </div>

                </div>
            </div>



        </div>
    )
}
